import { Action } from '../actions';

export const defaultState = {
  loading: false,
  updating: false,
  error: undefined,
  preferences: null,
};

export default function preferencesReducer(state = defaultState, action) {
  const body = action.payload || {};
  const { response } = body;

  switch (action.type) {
    case Action.Preferences.GetPending:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case Action.Preferences.GetCompleted:
      return {
        ...state,
        loading: false,
        error: undefined,
        preferences: response?.preferences || null,
      };

    case Action.Preferences.GetFailed:
      return {
        ...state,
        loading: false,
        error: response?.message || body.message || 'Failed to get preferences',
      };

    case Action.Preferences.UpdatePending:
      return {
        ...state,
        updating: true,
        error: undefined,
      };

    case Action.Preferences.UpdateCompleted:
      return {
        ...state,
        updating: false,
        error: undefined,
      };

    case Action.Preferences.UpdateFailed:
      return {
        ...state,
        updating: false,
        error: response?.message || body.message || 'Failed to update preferences',
      };

    default:
      return state;
  }
}
